import styled from 'styled-components'

export const LayoutContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: Outfit;
`

export const StyledLogo = styled.img`
  width: 35px;
  height: 35px;
  border-radius: 3px;
  margin: 0 auto 10px auto;
  @media (min-width: 768px) {
    width: 55px;
    height: 55px;
    border-radius: 6px;
  }
`
export const SidebarItemText = styled.span`
  color: ${({ disabled }) => (disabled ? '#8b8b8b' : '#fff')};
  font-family: Outfit;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  min-width: 130px;
  @media (min-width: 768px) {
    min-width: 170px;
    font-size: 20px;
  }
`
export const SidebarContainer = styled.div`
  width: 70px;
  min-height: 100vh;
  overflow: hidden;
  background: #434343;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  transition: all 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  color: #fff;
  font-family: Outfit;
  padding: 25px 18px;

  .sidebar-item {
    margin-left: 5px;
    @media (min-width: 768px) {
      margin-left: 24px;
    }
  }

  .sidebar-item-text {
    display: block;
    overflow: hidden;
    width: 0px;
    transition: width 200ms linear;
  }

  @media (min-width: 768px) {
    width: 100px;
  }

  &:hover {
    width: 160px;
    @media (min-width: 768px) {
      width: 230px;
    }
    .sidebar-item-text {
      width: 100%;
    }
  }
`

// &:hover {
//   width: 230px;
//   align-items: flex-start;
//   ${SidebarItemContainer} {
//     display: flex;
//   }
//   ${SidebarItemIcon} {
//     margin-left: 17px;
//   }
// }
// @media (min-width: 768px) {
//   width: 100px;
//   padding: 25px 25px;
//   &:hover {
//     width: 340px;
//     align-items: flex-start;
//     ${SidebarItemContainer} {
//       display: flex;
//     }
//     ${SidebarItemIcon} {
//       margin-left: 17px;
//     }
//   }
// }

export const SupportContentContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-left: ${(props) => (props?.removeLeftMargins ? 'unset' : '70px')};
  padding-right: 16px;
  background: #fafafa;
  flex: 1; /* Allow container to grow and push footer down */
  box-sizing: border-box;
  overflow-x: hidden;
  @media (min-width: 768px) {
    padding-left: ${(props) => (props?.removeLeftMargins ? 'unset' : '100px')};
    padding-right: 24px;
  }
`
